// Lightweight inline phone illustrations for the APK install guide.
const Frame = ({ children, label }) => (
  <svg viewBox="0 0 120 200" className="h-44 w-auto shrink-0 drop-shadow-[0_0_18px_rgba(245,197,66,0.18)]" role="img" aria-label={label}>
    <rect x="4" y="4" width="112" height="192" rx="18" fill="#0d0b0c" stroke="#f5c542" strokeOpacity="0.6" strokeWidth="2" />
    <rect x="12" y="20" width="96" height="160" rx="6" fill="#16191c" />
    <rect x="48" y="10" width="24" height="4" rx="2" fill="#f5c542" fillOpacity="0.4" />
    {children}
  </svg>
);

const Download = () => (
  <>
    <circle cx="60" cy="80" r="24" fill="#3fd6e0" fillOpacity="0.15" stroke="#3fd6e0" strokeWidth="2" />
    <path d="M60 66v24m-10-10 10 10 10-10" stroke="#3fd6e0" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="24" y="124" width="72" height="8" rx="4" fill="#2a2e33" />
    <rect x="24" y="124" width="48" height="8" rx="4" fill="#f5c542" />
    <rect x="30" y="144" width="60" height="18" rx="9" fill="#f5c542" />
  </>
);

const Open = () => (
  <>
    <rect x="18" y="28" width="84" height="30" rx="6" fill="#2a2e33" stroke="#f5c542" strokeOpacity="0.7" />
    <rect x="24" y="34" width="18" height="18" rx="4" fill="#3fd6e0" />
    <rect x="48" y="36" width="46" height="5" rx="2.5" fill="#e5e5e5" />
    <rect x="48" y="46" width="30" height="4" rx="2" fill="#8a8f96" />
    <rect x="18" y="72" width="84" height="20" rx="4" fill="#1f2326" />
    <rect x="18" y="98" width="84" height="20" rx="4" fill="#1f2326" />
    <circle cx="86" cy="45" r="9" fill="none" stroke="#e86ad8" strokeWidth="2.5" />
  </>
);

const Unknown = () => (
  <>
    <path d="M60 34l26 10v20c0 18-12 28-26 34-14-6-26-16-26-34V44z" fill="#d0141f" fillOpacity="0.25" stroke="#f5c542" strokeWidth="2" />
    <path d="M50 66l7 7 14-15" stroke="#f5c542" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="18" y="120" width="56" height="6" rx="3" fill="#e5e5e5" />
    <rect x="18" y="132" width="40" height="4" rx="2" fill="#8a8f96" />
    <rect x="80" y="118" width="24" height="14" rx="7" fill="#3fd6e0" />
    <circle cx="97" cy="125" r="5" fill="#fff" />
  </>
);

const Install = () => (
  <>
    <rect x="18" y="60" width="84" height="84" rx="10" fill="#22262a" stroke="#f5c542" strokeOpacity="0.5" />
    <rect x="48" y="70" width="24" height="24" rx="6" fill="#3fd6e0" />
    <rect x="30" y="102" width="60" height="5" rx="2.5" fill="#e5e5e5" />
    <rect x="28" y="120" width="28" height="14" rx="7" fill="#2a2e33" />
    <rect x="62" y="120" width="32" height="14" rx="7" fill="#f5c542" />
  </>
);

const Launch = () => (
  <>
    {[0, 1, 2].map((r) => [0, 1, 2].map((c) => (
      <rect key={`${r}${c}`} x={22 + c * 28} y={40 + r * 34} width="20" height="20" rx="5" fill={r === 1 && c === 1 ? "#e86ad8" : "#2a2e33"} />
    )))}
    <circle cx="60" cy="84" r="18" fill="none" stroke="#f5c542" strokeWidth="2" strokeDasharray="4 3" />
    <rect x="30" y="150" width="60" height="16" rx="8" fill="#f5c542" />
  </>
);

const ART = { download: Download, open: Open, unknown: Unknown, install: Install, launch: Launch };

export const PhoneArt = ({ kind, label }) => {
  const Art = ART[kind];
  return <Frame label={label}><Art /></Frame>;
};
